import { keyframes } from 'styled-components';

const slideIn = keyframes `
  from {
    width: 88px;
  }

  to {
    width: 360px;
  }
`;
const slideOut = keyframes `
  from {
    width: 360px;
  }

  to {
    width: 88px;
  }
`;
const slideDown = (height) => keyframes `
  from {
    height: 0;
  }

  to {
    height: ${height}px;
  }
`;
const slideUp = (height) => keyframes `
  from {
    height: ${height}px;
  }

  to {
    height: 0;
  }
`;
const initialSlide = (theme) => keyframes `
  from {
    width: 0;
    padding-inline: 0;
  }

  to {
    width: 88px;
    padding-inline: ${theme.olist.spacing.inline.small};
  }
`;
const fadeIn = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes `
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export { fadeIn, fadeOut, initialSlide, slideDown, slideIn, slideOut, slideUp };
